import styled from 'styled-components'
const tabletBreakpoints = props => props.theme.mediaQuery.up('mobile-landscape');
const smallDesktopBreakpoints = props => props.theme.mediaQuery.up('desktop-small');
const largeDesktopBreakpoints = props => props.theme.mediaQuery.up('desktop-large');

const getPage = () => {
    if (typeof window !== "undefined")
      return window.location.pathname;
    return '';
}

const pageType = getPage();
const isSearchPage = pageType.includes('search');

export const Header = styled.header`
  width: 100%;
  max-width: 100%;
  white-space: normal;
  min-height: 178px;

  ${tabletBreakpoints} {
    min-height: 124px;
  }
  
  ${smallDesktopBreakpoints} {
    min-height: ${isSearchPage ? '204px' :'124px'};
  }
  ${largeDesktopBreakpoints} {
    min-height: ${isSearchPage ? '243px' :'163px'};
  }
`
